export const RELATIVE_INTAKE_FORM_URL = `relatives-intake-form`;
export const CLIENT_INTAKE_FORM_URL = `clinical-intake-form-new`;
export const PATIENTRELATIVESINFORMATION = 'patient-relatives-information';
export const PATIENTEPORTINFORMATION = '/patient-report-information-new';
export const DOCTORASSESMENTINFORMATIONPAGE = 'patient-assessment-page';
export const PATIENTASSESMENTINFORMATIONPAGE = 'assessment';
export const PAITENT_DETAILS = 'patient-details';
export const SETTINGS = '/settings';

export const RECORDINGINFORMATIONPAGE = 'recording-information-page';


export const RELATIVE_INTAKE_SUBMIT_URL = 'relatives-submit-detail';

export const RELATIVEFROMDETAIL = 'relative-form-detail';


export const ADMINHOME = '/admin/home';
export const ADMINPROMPTPAGE = '/admin/prompts';
export const ADMINPROMPTSADD = '/admin/prompts/add';
export const ADMINPROMPTSEDIT = '/admin/prompts/view';

export const ADMINTEMPLATEPAGE = '/admin/template';
export const ADMINTEMPLATESADD = '/admin/template/add';
export const ADMINTEMPLATESEDIT = '/admin/template/view';
export const ADMINTEMPLATEGUIDELINE = '/admin/template/guideline';

export const ADMINSUPPORTPAGE = '/admin/support-request';

export const ADMINSUBSCRIPTIONPAGE = '/admin/subscription';
export const ADMINSUBSCRIPTIONEDIT = '/admin/subscription/view';



export const ADMINUSERCLINICIANSPAGE = '/admin/user/clinicians';


// ---------------------- CMS MENU -----------------------
export const ADMINCMS = '/admin/cms';
export const ADMINCMSTESTIMONIALPAGE = '/admin/cms/testimonials';
export const ADMINCMSTESTIMONIALADD = '/admin/cms/testimonials/new';
export const ADMINCMSTESTIMONIALUPDATE = '/admin/cms/testimonials/update';


export const ADMINCMSFAQSPAGE = '/admin/cms/faq';
export const ADMINCMSFAQADD = '/admin/cms/faq/new';
export const ADMINCMSFAQUPDATE = '/admin/cms/faq/update';
export const ADMINCMSABOUTPAGE = '/admin/cms/about';
export const ADMINCMSSERVICEPAGE = '/admin/cms/service';
export const ADMINCMSPRIVACYPAGE = '/admin/cms/privacy';
export const ADMINCMSTERMSPAGE = '/admin/cms/terms';
export const ADMINCONTACTUSPAGE = '/admin/cms/contact-us';
export const ADMINSOCIALMEDIAPAGE = '/admin/cms/social-media';
export const ADMINSOCIALMEDIAADD = '/admin/cms/social-media/new';
export const ADMINSOCIALMEDIAUPDATE = '/admin/cms/social-media/update';


